import {createContext} from 'react';
import {ColorPickerLayout} from './color-picker-v2.types';

/** Layout a ColorPicker uses when no `layout` prop is passed; ColorPickerV2Popover provides POPUP to everything it hosts. */
export const ColorPickerLayoutContext = createContext<ColorPickerLayout>(ColorPickerLayout.PANEL);
